import { Table } from 'antd';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import moment from 'moment';

import { Spinner } from '../../../../components/data/Spinner';
import { DateTimeFormatNumeric } from '../../../../utils/dateFormatting';
import { useNewShipmentFlightInformationFormStyles } from '../../newShipment/NewShipmentFlightInformationForm.styles';

function Flights({ flights, onClick }) {
  const { formatMessage } = useIntl();
  const { styles } = useNewShipmentFlightInformationFormStyles();

  const fixedColumns = [
    {
      title: formatMessage({ id: 'book.newAirRetrieval.search.flight' }),
      dataIndex: 'airline',
    },
    {
      title: formatMessage({ id: 'book.newAirRetrieval.search.flightNumber' }),
      dataIndex: 'flightNumber',
      width: 60,
    },
    {
      title: formatMessage({ id: 'book.newAirRetrieval.search.route' }),
      width: 100,
      render: record =>
        `${record?.departureAirport} → ${record?.arrivalAirport}`,
    },
    {
      title: formatMessage({ id: 'book.newAirRetrieval.search.departure' }),
      dataIndex: 'departureDatetime',
      width: 150,
      render: text => (
        <DateTimeFormatNumeric value={moment(text)} separator=" | " />
      ),
    },
    {
      title: formatMessage({ id: 'book.newAirRetrieval.search.arrival' }),
      dataIndex: 'arrivalDatetime',
      width: 150,
      render: text => (
        <DateTimeFormatNumeric value={moment(text)} separator=" | " />
      ),
    },
  ];

  return (
    <Table
      columns={fixedColumns}
      rowClassName={styles.flightsTableRow}
      dataSource={flights}
      scroll={{ y: 200 }}
      pagination={false}
      onRow={record => ({
        onClick: () => onClick(record),
        'data-subject': 'flights-table',
        'data-action': 'row',
      })}
      locale={{
        emptyText: (
          <FormattedMessage id="book.newAirRetrieval.search.emptyText" />
        ),
      }}
    />
  );
}

export default function SearchFlightsPopoverContent({
  flights,
  isLoading,
  onClick,
}) {
  const { styles } = useNewShipmentFlightInformationFormStyles();

  return (
    <div className={styles.searchFlightsPopoverContent}>
      {isLoading ? (
        <Spinner />
      ) : (
        <Flights flights={flights} onClick={onClick} />
      )}
    </div>
  );
}
